export const SET_BLINK_CARD_PACK = 'SET_BLINK_CARD_PACK';

export const UPDATE_BLINK_CARD_INFO = 'UPDATE_BLINK_CARD_INFO';
